export const CUSTOM_SCREEN_SET_INITIAL_STATE = 'CUSTOM_SCREEN_SET_INITIAL_STATE';
export const CUSTOM_SCREEN_FIND_ALL = 'CUSTOM_SCREEN_FIND_ALL';
export const CUSTOM_SCREEN_VIEW = 'CUSTOM_SCREEN_VIEW';
